// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2-Dle","header":"ReportDetails_header__2WXMe","title":"ReportDetails_title__e4kn4","left":"ReportDetails_left__x-QF9"};